import { createSlice } from '@reduxjs/toolkit';

const likeCollectionIdSlice = createSlice({
    name: 'likeCollectionId',
    initialState: false,
    reducers: {
        setLikeCollectionId: (state, action) => action.payload,
    },
});

export const { setLikeCollectionId } = likeCollectionIdSlice.actions;

export default likeCollectionIdSlice.reducer;
